var _path, _g, _rect, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 29.75C37.2096 29.7497 41.25 26.0752 41.25 21.75C41.25 17.4246 37.2094 13.75 32 13.75C26.7906 13.75 22.75 17.4259 22.75 21.75C22.75 23.7312 23.584 25.5571 24.9934 26.9706C25.0712 27.0487 25.1308 27.143 25.168 27.2467C25.205 27.35 25.2189 27.4601 25.2087 27.5693C25.1238 28.3847 24.9634 29.1904 24.7295 29.9761L24.4844 30.7997L25.3215 30.6059C27.1048 30.193 28.2078 29.7116 28.7272 29.4486L28.5063 29.0125L28.7272 29.4486C28.8918 29.3652 29.0814 29.3454 29.2597 29.3931C30.1536 29.6323 31.0752 29.7523 32.0005 29.75ZM32.0005 29.75C32.0004 29.75 32.0002 29.75 32 29.75V29.25L32.0013 29.75C32.001 29.75 32.0008 29.75 32.0005 29.75ZM25.7017 26.2646L25.7016 26.2644C24.4585 25.0179 23.75 23.4388 23.75 21.75C23.75 18.0941 27.2194 14.75 32 14.75C36.7806 14.75 40.25 18.0929 40.25 21.75C40.25 25.4071 36.7806 28.75 32 28.75L31.9987 28.75C31.1612 28.7522 30.3271 28.6435 29.518 28.427L29.5178 28.4269C29.1018 28.3158 28.6595 28.3619 28.2753 28.5564C27.9037 28.7447 27.1336 29.0889 25.9092 29.426C26.0438 28.8478 26.1421 28.2615 26.2036 27.6705L26.2036 27.6705L26.204 27.6664C26.2285 27.4102 26.1962 27.1517 26.1094 26.9094C26.0226 26.6671 25.8834 26.447 25.7017 26.2646ZM24.2765 30.5741L24.2798 30.5646L24.2827 30.5549L24.2835 30.552C24.6019 29.6257 24.8635 28.5555 24.9602 27.5478L24.9827 27.3135L24.8165 27.1469C23.3659 25.6928 22.5 23.8037 22.5 21.75C22.5 17.2543 26.6888 13.5 32 13.5C37.3112 13.5 41.5 17.2543 41.5 21.75C41.5 26.2457 37.3112 30 32 30L31.9989 30C31.0524 30.0021 30.1098 29.8792 29.1955 29.6345L29.011 29.5851L28.8406 29.6713C28.2309 29.9797 26.8753 30.5635 24.6339 31.0083C24.4489 31.0449 24.2635 31.0796 24.0777 31.1124C24.1479 30.9344 24.2142 30.755 24.2765 30.5741Z",
    stroke: "#50595F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3475 70.6175C25.4772 70.7477 25.5767 70.905 25.6387 71.0781C25.7007 71.2511 25.7238 71.4357 25.7062 71.6188C25.6182 72.4657 25.4516 73.3026 25.2087 74.1187C26.9525 73.715 28.0175 73.2475 28.5013 73.0025C28.7756 72.8635 29.0916 72.8306 29.3887 72.91C30.2404 73.1379 31.1184 73.2523 32 73.25C36.995 73.25 40.75 69.7413 40.75 65.75C40.75 61.7587 36.995 58.25 32 58.25C27.005 58.25 23.25 61.76 23.25 65.75C23.25 67.585 24.0212 69.2875 25.3475 70.6175ZM24.7312 75.4988C24.4351 75.5574 24.1379 75.6111 23.84 75.66C23.59 75.7 23.4 75.44 23.4987 75.2075C23.6094 74.9456 23.7112 74.6801 23.8037 74.4113L23.8075 74.3988C24.1175 73.4988 24.37 72.4638 24.4625 71.5C22.9288 69.9625 22 67.95 22 65.75C22 60.9175 26.4775 57 32 57C37.5225 57 42 60.9175 42 65.75C42 70.5825 37.5225 74.5 32 74.5C31.0095 74.5022 30.0231 74.3736 29.0662 74.1175C28.4162 74.4463 27.0175 75.045 24.7312 75.4988Z",
    fill: "url(#paint0_linear_1_263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3475 70.6175C25.4772 70.7477 25.5767 70.905 25.6387 71.0781C25.7007 71.2511 25.7238 71.4357 25.7062 71.6188C25.6182 72.4657 25.4516 73.3026 25.2087 74.1187C26.9525 73.715 28.0175 73.2475 28.5013 73.0025C28.7756 72.8635 29.0916 72.8306 29.3887 72.91C30.2404 73.1379 31.1184 73.2523 32 73.25C36.995 73.25 40.75 69.7413 40.75 65.75C40.75 61.7587 36.995 58.25 32 58.25C27.005 58.25 23.25 61.76 23.25 65.75C23.25 67.585 24.0212 69.2875 25.3475 70.6175Z",
    fill: "url(#paint1_linear_1_263)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3475 114.618C25.4772 114.748 25.5767 114.905 25.6387 115.078C25.7007 115.251 25.7238 115.436 25.7062 115.619C25.6182 116.466 25.4516 117.303 25.2087 118.119C26.9525 117.715 28.0175 117.248 28.5013 117.003C28.7756 116.864 29.0916 116.831 29.3887 116.91C30.2404 117.138 31.1184 117.252 32 117.25C36.995 117.25 40.75 113.741 40.75 109.75C40.75 105.759 36.995 102.25 32 102.25C27.005 102.25 23.25 105.76 23.25 109.75C23.25 111.585 24.0212 113.287 25.3475 114.618ZM24.7312 119.499C24.4351 119.557 24.1379 119.611 23.84 119.66C23.59 119.7 23.4 119.44 23.4987 119.208C23.6094 118.946 23.7112 118.68 23.8037 118.411L23.8075 118.399C24.1175 117.499 24.37 116.464 24.4625 115.5C22.9288 113.963 22 111.95 22 109.75C22 104.918 26.4775 101 32 101C37.5225 101 42 104.918 42 109.75C42 114.583 37.5225 118.5 32 118.5C31.0095 118.502 30.0231 118.374 29.0662 118.118C28.4162 118.446 27.0175 119.045 24.7312 119.499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3475 114.618C25.4772 114.748 25.5767 114.905 25.6387 115.078C25.7007 115.251 25.7238 115.436 25.7062 115.619C25.6182 116.466 25.4516 117.303 25.2087 118.119C26.9525 117.715 28.0175 117.248 28.5013 117.003C28.7756 116.864 29.0916 116.831 29.3887 116.91C30.2404 117.138 31.1184 117.252 32 117.25C36.995 117.25 40.75 113.741 40.75 109.75C40.75 105.759 36.995 102.25 32 102.25C27.005 102.25 23.25 105.76 23.25 109.75C23.25 111.585 24.0212 113.287 25.3475 114.618Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_263",
    x: 18,
    y: 55,
    width: 28,
    height: 26.6641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_263",
    x1: 32,
    y1: 57,
    x2: 32,
    y2: 75.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_263",
    x1: 32,
    y1: 57,
    x2: 32,
    y2: 75.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8f3031910f28080fdd00b9afb0ef69a1.svg";
export { ForwardRef as ReactComponent };